import { handleActions } from 'redux-actions';

const defaultState = {
  loading: false,
  error: { type: null, message: null }
};

const handleStartApp = state => ({
  ...state,
  loading: true,
  error: { type: null, message: null }
});
const handleStartAppFailure = state => ({
  ...state,
  loading: false,
  error: { type: 'START_APP_ERROR', message: '404 Not Found' }
});
const handleStartAppTimeout = state => ({
  ...state,
  loading: false,
  error: { type: 'START_APP_ERROR', message: '408 Request Timeout' }
});
const handleStartAppCancel = state => ({
  ...state,
  loading: false,
  error: { type: 'START_APP_ERROR', message: '400 Request Cancelled' }
});
const handleStartAppComplete = state => ({
  ...state,
  loading: false,
  error: { type: null, message: null }
});

export default handleActions({
  START_APP: handleStartApp,
  START_APP_COMPLETE: handleStartAppComplete,
  START_APP_FAILURE: handleStartAppFailure,
  START_APP_TIMEOUT: handleStartAppTimeout,
  START_APP_CANCEL: handleStartAppCancel
}, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/StartApp.Reducer.js